module.exports = __webpack_public_path__ + "static/dialiv-17ec6a77f4df8a90dcf627c27841e51f.png";